
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// GK 2026-04-23 This allows us to scroll to a hash (eg. clicking around the Support page)
const ScrollToHash = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);

  return null;
};

export default ScrollToHash;